module.exports = __webpack_public_path__ + "img/2.c6f4e813.png";